import { configureStore } from "@reduxjs/toolkit";
import { rootReducer } from "./rootReducer";
import { auditManagerApiSlice } from "@callveriq/redux/services/settings/auditManager.service";
import { roleManagerApiSlice } from "@callveriq/redux/services/settings/roleManager.service";
import { violationManagerApiSlice } from "@callveriq/redux/services/settings/violationManager.service";
import { rtkQueryErrorLogger } from "@callveriq/redux/middleware/errorhandler";
import { callTypeManagerApiSlice } from "@callveriq/redux/services/settings/callTypeManager.service";
import { callTagsManagerApiSlice } from "@callveriq/redux/services/settings/callTagsManager.service";
import { usersApiSlice } from "@callveriq/redux/services/settings/users.service";
import { scoreSenseApiSlice } from "@callveriq/redux/services/settings/scoreSense.service";
import { qmsApiSlice } from "@callveriq/redux/services/settings/qms.service";
import { customDashboardApiSlice } from "@callveriq/redux/services/home/customDashboard.service";
import { accountsApiSlice } from "@callveriq/redux/services/account/account.service";
import { entityApiSlice } from "@callveriq/redux/services/settings/entity.service";
import { activityApiSlice } from "@callveriq/redux/services/settings/activity.service";
import { userManagerApiSlice } from "@callveriq/redux/services/settings/userManager.service";
import { teamManagerSeviceSlice } from "@callveriq/redux/services/settings/teamManager.service";
import { billingApiSlice } from "@callveriq/redux/services/settings/billing.service";
import { analyticsDashboardApiSlice } from "@callveriq/redux/services/home/analyticsDashboard.service";
import { feedbackSlice } from "@callveriq/redux/services/Feedback/feedback.service";
import { scheduledReportsApiSlice } from "@callveriq/redux/services/settings/scheduledReport.service";
import { liveAssistApiSlice } from "@callveriq/redux/services/settings/liveAssist.service";
import { domainApiSlice } from "@callveriq/redux/services/domain/domain.service";
import { lmsKnowledgeBaseApiSlice } from "@callveriq/redux/services/lms/lmsKnowledgeBase.service";
import { lmsAssessmentApiSlice } from "@callveriq/redux/services/lms/lmsAssesments.service";
import { customerIntelligenceApiSlice } from "@callveriq/redux/services/customerIntelligence/customerIntelligence.service";
import { aiFeedbackSlice } from "@callveriq/redux/services/settings/aiFeedback.service";
import { notificationApiSlice } from "@callveriq/redux/services/notifications/notification.service";
import { supervisorAssistApiSlice } from "@callveriq/redux/services/supervisorAssist/supervisorAssist.service";
import { aiVoiceCallSlice } from "@callveriq/redux/services/aiVoiceCall/aiVoiceCall.service";
import { samplingManagerApiSlice } from "@callveriq/redux/services/settings/samplingManager.service";
import { filtersApiSlice } from "@callveriq/redux/services/meeting/filters.service";
import { conversationsApiSlice } from "@callveriq/redux/services/conversation/conversations.service";
import { commentApiSlice } from "@callveriq/redux/services/comment/comment.service";
import { auditSheetApiSlice } from "@callveriq/redux/services/audit/auditSheet.service";
import { meetingsApiSlice } from "@callveriq/redux/services/meeting/meeting.service";
import { authApiSlice } from "@callveriq/redux/services/auth/auth.service";
import { recommendationApiSlice } from "@callveriq/redux/services/settings/recommendation.service";
import { auditAiConfig } from "@callveriq/redux/services/settings/auditAiConfig.service";
import { coachingApiSlice } from "@callveriq/redux/services/coaching/coaching.service";
import { aiDispositionApiSlice } from "@callveriq/redux/services/settings/aiDisposition.service";
import { aiSummaryApiSlice } from "@callveriq/redux/services/settings/aiSummary.service";
import { personApiSlice } from "@callveriq/redux/services/auth/person.service";
import { internalCoachingApiSlice } from "@callveriq/redux/services/settings/internalCoaching.service";
import { recordingManagerApiSlice } from "@callveriq/redux/services/settings/recordingManager.service";
import { sentimentAnalysisApiSlice } from "@callveriq/redux/services/settings/sentimentAnalysis.service";
import { topicManagerApiSlice } from "@callveriq/redux/services/settings/topicManager.service";
import { integrationManagerApiSlice } from "@callveriq/redux/services/settings/integrationManager.service";
import { liveConversationApiSlice } from "@callveriq/redux/services/settings/liveConversation.service";
import { acptApiSlice } from "@callveriq/redux/services/settings/acpt.service";
import { internalAHTApiSlice } from "@callveriq/redux/services/settings/internalAHT.service";
import { dashboardReportConfigApiSlice } from "@callveriq/redux/services/settings/dashboardReportConfig.service";
import { subdomainConfigApiSlice } from "@callveriq/redux/services/settings/subdomainConfig.service";
import { internalToolsApiSlice } from "@callveriq/redux/services/settings/internalTools/internalTools.service";

export const store = configureStore({
    reducer: rootReducer,
    devTools: !import.meta.env.PROD,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            immutableCheck: false,
            serializableCheck: false,
        }).concat(
            auditManagerApiSlice.middleware,
            roleManagerApiSlice.middleware,
            violationManagerApiSlice.middleware,
            callTypeManagerApiSlice.middleware,
            internalCoachingApiSlice.middleware,
            callTagsManagerApiSlice.middleware,
            usersApiSlice.middleware,
            scoreSenseApiSlice.middleware,
            aiFeedbackSlice.middleware,
            qmsApiSlice.middleware,
            customDashboardApiSlice.middleware,
            accountsApiSlice.middleware,
            activityApiSlice.middleware,
            userManagerApiSlice.middleware,
            teamManagerSeviceSlice.middleware,
            entityApiSlice.middleware,
            domainApiSlice.middleware,
            billingApiSlice.middleware,
            lmsKnowledgeBaseApiSlice.middleware,
            lmsAssessmentApiSlice.middleware,
            analyticsDashboardApiSlice.middleware,
            feedbackSlice.middleware,
            scheduledReportsApiSlice.middleware,
            customerIntelligenceApiSlice.middleware,
            internalAHTApiSlice.middleware,
            dashboardReportConfigApiSlice.middleware,
            subdomainConfigApiSlice.middleware,
            internalToolsApiSlice.middleware,
            liveAssistApiSlice.middleware,
            aiSummaryApiSlice.middleware,
            acptApiSlice.middleware,
            notificationApiSlice.middleware,
            supervisorAssistApiSlice.middleware,
            aiVoiceCallSlice.middleware,
            samplingManagerApiSlice.middleware,
            filtersApiSlice.middleware,
            conversationsApiSlice.middleware,
            commentApiSlice.middleware,
            auditSheetApiSlice.middleware,
            meetingsApiSlice.middleware,
            authApiSlice.middleware,
            recommendationApiSlice.middleware,
            recordingManagerApiSlice.middleware,
            auditAiConfig.middleware,
            coachingApiSlice.middleware,
            sentimentAnalysisApiSlice.middleware,
            aiDispositionApiSlice.middleware,
            personApiSlice.middleware,
            topicManagerApiSlice.middleware,
            integrationManagerApiSlice.middleware,
            liveConversationApiSlice.middleware,
            rtkQueryErrorLogger
        ),
});

export const { dispatch } = store;
